import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ListViewColumn} from '../list-view.component';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {cloneDeep} from 'lodash-es';
import {NotificationService} from '../../notification.service';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';
import {ListViewPreferencesService} from '../list-view-preferences.service';

@Component({
    selector: 'displayed-columns-dialog',
    templateUrl: 'displayed-columns-dialog.component.html',
    styleUrls: ['displayed-columns-dialog.component.scss'],
    standalone: false
})
export class DisplayedColumnsDialogComponent<T> {
  public columns: ListViewColumn<T>[];
  public initialColumns: ListViewColumn<T>[];
  public defaultColumns: ListViewColumn<T>[];
  public listIdentifier: string;

  public showBoundMatSelectionList = true;

  customAtttributesExists = false;

  get areAllSelected(): boolean {
    return this.columns.filter(column => !column.selected).length === 0;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      columns: ListViewColumn<T>[],
      initialColumns: ListViewColumn<T>[],
      defaultColumns: ListViewColumn<T>[],
      listIdentifier: string },
    protected ref: ChangeDetectorRef,
    private dialogRef: MatDialogRef<DisplayedColumnsDialogComponent<T>>,
    public notificationService: NotificationService,
    private translateService: TranslateService,
    public preferencesService: ListViewPreferencesService<T>,
  ) {

    this.columns = cloneDeep(data.columns.filter(item => item.columnDef !== 'checkbox'));
    this.initialColumns = cloneDeep(data.initialColumns.filter(item => item.columnDef !== 'checkbox'));
    this.defaultColumns = cloneDeep(data.defaultColumns.filter(item => item.columnDef !== 'checkbox'));
    this.listIdentifier = data.listIdentifier;
    this.customAtttributesExists = data.columns.filter( column => {
      return (column.isCustomAttribute === true);
    }).length > 0;
  }

  toggle(column: ListViewColumn<T>): void {
    column.selected = !column.selected;
  }

  toggleSelectAll(change: MatCheckboxChange): void {
    this.columns.forEach(column => column.selected = change.checked);
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
  }

  save(): void {
    if (this.columns.filter( item => item.selected === true).length === 0) {
      const message = this.translateService.stream(marker('At least one column should be selected.'));
      this.notificationService.warn(message);
      return;
    }
    this.dialogRef.close(this.columns);
  }

  resetToDefault(): void {
    this.showBoundMatSelectionList = false;
    this.ref.detectChanges();

    this.columns = cloneDeep(this.defaultColumns);
    this.preferencesService.setColumnsToLocalStorage(this.listIdentifier, this.columns);

    this.showBoundMatSelectionList = true;
    this.ref.detectChanges();
    this.dialogRef.close(this.columns);
  }

}
